export var createEmptySiblingsBookings = function () { return ({
    hasSiblingsBookings: false,
    siblingNames: [],
    siblingsClientId: null,
    date: null,
}); };
export var NewBookingsStatus;
(function (NewBookingsStatus) {
    NewBookingsStatus[NewBookingsStatus["Initial"] = 0] = "Initial";
    NewBookingsStatus[NewBookingsStatus["FetchingAvailability"] = 1] = "FetchingAvailability";
    NewBookingsStatus[NewBookingsStatus["FetchAvailabilitySuccess"] = 2] = "FetchAvailabilitySuccess";
    NewBookingsStatus[NewBookingsStatus["FetchingSlots"] = 3] = "FetchingSlots";
    NewBookingsStatus[NewBookingsStatus["FetchSlotsSuccess"] = 4] = "FetchSlotsSuccess";
    NewBookingsStatus[NewBookingsStatus["FetchingSiblingsBookings"] = 5] = "FetchingSiblingsBookings";
    NewBookingsStatus[NewBookingsStatus["FetchSiblingsBookingsSuccess"] = 6] = "FetchSiblingsBookingsSuccess";
    NewBookingsStatus[NewBookingsStatus["Saving"] = 7] = "Saving";
    NewBookingsStatus[NewBookingsStatus["SaveSuccess"] = 8] = "SaveSuccess";
    NewBookingsStatus[NewBookingsStatus["SavingForDeposit"] = 9] = "SavingForDeposit";
    NewBookingsStatus[NewBookingsStatus["SaveForDepositSuccess"] = 10] = "SaveForDepositSuccess";
    NewBookingsStatus[NewBookingsStatus["FetchingPetServices"] = 11] = "FetchingPetServices";
    NewBookingsStatus[NewBookingsStatus["FetchPetServicesSuccess"] = 12] = "FetchPetServicesSuccess";
    NewBookingsStatus[NewBookingsStatus["RecurrentRescheduling"] = 13] = "RecurrentRescheduling";
    NewBookingsStatus[NewBookingsStatus["RecurrentRescheduleSuccess"] = 14] = "RecurrentRescheduleSuccess";
    NewBookingsStatus[NewBookingsStatus["SingleRescheduling"] = 15] = "SingleRescheduling";
    NewBookingsStatus[NewBookingsStatus["SingleRescheduleSuccess"] = 16] = "SingleRescheduleSuccess";
    NewBookingsStatus[NewBookingsStatus["SingleMultipleRescheduling"] = 17] = "SingleMultipleRescheduling";
    NewBookingsStatus[NewBookingsStatus["SingleMultipleRescheduleSuccess"] = 18] = "SingleMultipleRescheduleSuccess";
    NewBookingsStatus[NewBookingsStatus["FetchingAlerts"] = 19] = "FetchingAlerts";
    NewBookingsStatus[NewBookingsStatus["FetchAlertsSuccess"] = 20] = "FetchAlertsSuccess";
    NewBookingsStatus[NewBookingsStatus["SavingMultiple"] = 21] = "SavingMultiple";
    NewBookingsStatus[NewBookingsStatus["SaveMultipleSuccess"] = 22] = "SaveMultipleSuccess";
    NewBookingsStatus[NewBookingsStatus["ChangingStatus"] = 23] = "ChangingStatus";
    NewBookingsStatus[NewBookingsStatus["ChangeStatusSuccess"] = 24] = "ChangeStatusSuccess";
    NewBookingsStatus[NewBookingsStatus["SavingMultipleBookingForDeposit"] = 25] = "SavingMultipleBookingForDeposit";
    NewBookingsStatus[NewBookingsStatus["SaveMultipleBookingForDepositSuccess"] = 26] = "SaveMultipleBookingForDepositSuccess";
    NewBookingsStatus[NewBookingsStatus["SavingCreateAppointment"] = 27] = "SavingCreateAppointment";
    NewBookingsStatus[NewBookingsStatus["SavingCreateAppointmentSuccess"] = 28] = "SavingCreateAppointmentSuccess";
    NewBookingsStatus[NewBookingsStatus["NotFound"] = 29] = "NotFound";
    NewBookingsStatus[NewBookingsStatus["Error"] = 30] = "Error";
})(NewBookingsStatus || (NewBookingsStatus = {}));
